// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__PxxIj","about_us":"Footer_about_us__HFP+V","contact_info":"Footer_contact_info__JIZ5Q","footer_title":"Footer_footer_title__duCd2"};